"use client";

import { useState, useEffect } from "react";
import { getPublicSetting } from "@/app/lib/api/public";
import { Setting } from "@/app/lib/api/settings";
import toast from "react-hot-toast";
import { AboutPageSkeleton } from "@/app/components/skeletons/page-skeletons";

export default function AboutPage() {
  const [aboutContent, setAboutContent] = useState<Setting | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAboutContent = async () => {
      try {
        setLoading(true);
        const content = await getPublicSetting(16);
        setAboutContent(content);
      } catch (error) {
        console.error("Error fetching about content:", error);
        toast.error("İçerik yüklenirken bir hata oluştu");
      } finally {
        setLoading(false);
      }
    };

    fetchAboutContent();
  }, []);

  if (loading) {
    return <AboutPageSkeleton />;
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="relative">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gray-300 via-orange-400 to-gray-300"></div>
            <div className="p-8">
              <h1 className="text-3xl font-bold text-gray-800 mb-6 relative inline-block">
                Hakkımızda
                <span className="absolute -bottom-1 left-0 w-full h-1 bg-gray-400"></span>
              </h1>
              
              {aboutContent ? (
                <div className="prose prose-lg max-w-none">
                  {/* Display the content as HTML if it contains HTML tags, otherwise as plain text */}
                  {aboutContent.value.includes("<") ? (
                    <div dangerouslySetInnerHTML={{ __html: aboutContent.value }} />
                  ) : (
                    <p className="text-gray-700 whitespace-pre-wrap">{aboutContent.value}</p>
                  )}
                </div>
              ) : (
                <p className="text-gray-500 italic">İçerik bulunamadı.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 